import React from "react";
import PropTypes from "prop-types";
import tracking from "@irati-tracking/platform";
import { StyledLink, StyledRouterLink } from "./styled";
var TenantProductLink = function (props, _a) {
    var apps = _a.apps;
    var cardId = props.cardId, children = props.children, href = props.href, product = props.product, trackingName = props.trackingName, to = props.to;
    if (to) {
        return (React.createElement(StyledRouterLink, { id: cardId, to: to, app: apps[product.product], onClick: function () { return tracking.click("homepage_card", { product: trackingName, active: true }); }, plain: true }, children));
    }
    if (href) {
        return (React.createElement(StyledLink, { id: cardId, href: href, target: "_blank", onClick: function () { return tracking.click("homepage_card", { product: trackingName, active: false }); }, plain: true }, children));
    }
    return children;
};
TenantProductLink.contextTypes = {
    apps: PropTypes.object
};
export default TenantProductLink;
